import React, { useEffect } from 'react';
import { privacyComplianceDocuments, privacyComplianceMeta } from '../../content/privacyCompliance';
import { renderLegalParagraph } from '../../content/legalText';
import './style.css';

const documentLinks = [
  ['隐私政策', '/privacy'],
  ['用户协议', '/user-agreement'],
  ['个人信息收集清单', '/personal-info-list'],
  ['第三方 SDK 清单', '/sdk-list'],
  ['账号注销', '/account-deletion'],
];

function LegalDocument({ documentKey }) {
  const legalDocument = privacyComplianceDocuments[documentKey] || privacyComplianceDocuments.privacyPolicy;

  useEffect(() => {
    window.document.title = `${legalDocument.title} - 佣值选`;
    return () => {
      window.document.title = '佣值选';
    };
  }, [legalDocument.title]);

  return (
    <main className="legal-page">
      <header className="legal-header">
        <div className="legal-header__inner">
          <a className="legal-brand" href="/" aria-label="返回佣值选下载页">
            <span className="legal-brand__mark">佣</span>
            <span>佣值选</span>
          </a>
          <nav className="legal-nav" aria-label="法律文档导航">
            {documentLinks.map(([label, href]) => (
              <a key={`${href}-${label}`} href={href}>{label}</a>
            ))}
          </nav>
        </div>
      </header>

      <section className="legal-hero">
        <div className="legal-shell">
          <p className="legal-eyebrow">{privacyComplianceMeta.appName}</p>
          <h1>{legalDocument.title}</h1>
          <p>{legalDocument.summary}</p>
          <div className="legal-meta">
            <span>版本 {privacyComplianceMeta.policyVersion}</span>
            <span>生效日期 {privacyComplianceMeta.effectiveDate}</span>
            <span>更新日期 {privacyComplianceMeta.updatedDate}</span>
          </div>
        </div>
      </section>

      <article className="legal-content legal-shell">
        {legalDocument.sections.map((section, index) => (
          <section className="legal-section" key={section.title} id={index === 0 && documentKey === 'personalInfoList' ? 'collection' : undefined}>
            <h2>{index + 1}. {section.title}</h2>
            {section.paragraphs.map((paragraph, paragraphIndex) => renderLegalParagraph(
              React,
              paragraph,
              { sensitive: section.paragraphStyles?.[paragraphIndex] === 'sensitive' }
            ))}
          </section>
        ))}
      </article>

      <footer className="legal-footer">
        <div className="legal-shell legal-footer__inner">
          <div>
            <strong>{privacyComplianceMeta.operator}</strong>
            <p>客服邮箱：<a href={`mailto:${privacyComplianceMeta.supportEmail}`}>{privacyComplianceMeta.supportEmail}</a></p>
          </div>
          <a href="/">返回官方下载页</a>
        </div>
      </footer>
    </main>
  );
}

export default LegalDocument;
